import React from "react";
import buildQuizState from "../articleFunctions/buildQuizState";

export default function CheckQuizForm({id, name, indicatorColor, content, quizContent, setQuizContent}) {
    return (
        <div className="oneCheckbox">
            <input type="checkbox" name={name} />
            <span 
                className="lengthIndicator"
                style={{"color": indicatorColor}}>
                {(content) ? content.length : 0} / 30
            </span>
            <label htmlFor={name}>
                <input type="text" id={id}
                    onChange={() => buildQuizState("checkbox", quizContent, setQuizContent)}
                    value={content ? content : "" }/>
            </label>
        </div>
    )
}
